// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loading_loader__fHWHo","spin":"Loading_spin__27TzB"};